export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/valorant.2114ca7.svg";